import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';
import { fetchServices } from '../../../../../../../actions/services-api';
import { PensionDetails } from './pensionDetails';
import { ConnectionTypes, FrenchTypes } from '../../../../../../../constants/utils/connectionTypes';
import { set } from 'date-fns';
import { LoadingState } from '../../../../../../../_common/loadingState';

export const Pension = ({ userId, serviceDatas, disableModifications, generateLetters }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [pensionState, setPensionState] = useState({
        items: [{}],
        services: []
    });


    useEffect(() => {
        let isMounted = true;
        
        const fetchData = async () => {
            if (R.isEmpty(pensionState.services)) {
                setIsLoading(true);
                let elements = await dispatch(fetchServices(ConnectionTypes.pension));
                if (isMounted) {
                    let elementsToAdd = elements.items.filter(e => e.serviceName != "ONaCVG" && e.mapping);
                    setPensionState({ ...pensionState, items: R.isEmpty(pensionState.items.filter(i => !R.isEmpty(i))) ? [{}] : [...pensionState.items.filter(i => !R.isEmpty(i) && i.serviceName != "ONaCVG")], services: pensionState.services.concat(elementsToAdd) });
                    setIsLoading(false);
                }
            }
        };
        
        fetchData();
        
        return () => {
            isMounted = false;
        };
    }, [pensionState]);

    useEffect(() => {
        const pensionsInState = serviceDatas.filter(s => s.serviceType === FrenchTypes.pension);
        if (pensionsInState.length > 0) {
            setPensionState({
                ...pensionState,
                items: pensionsInState
            });
        } else {
            //setPensionState({...pensionState, items: [{}]});
        }
    }, [serviceDatas]);

    function removePension(pension) {
        setPensionState({ ...pensionState, items: pensionState.items.filter(a => a !== pension) });
    }

    // if (true) {
    //     return (<div class="d-flex justify-content-center">
    //         <div class="spinner-border" role="status">
    //             <span class="visually-hidden"></span>
    //         </div>
    //     </div>);
    // }

    if (isLoading) {
        return <div className='mt-4'><LoadingState /></div>;
    }
    if (R.isEmpty(pensionState.services)) {
        return '';
    }
    return (
        <article className="block" id="activité">
            <h3 className="sr-only visually-hidden">Retraite</h3>
            {
                pensionState.items.map((item, index) => {
                    return <PensionDetails key={index} index={index} userId={userId} pension={item} removePension={removePension} services={pensionState.services} disableModifications={disableModifications} generateLetters={generateLetters} />;
                })

            }

            <footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
                <h4 className="sr-only visually-hidden">Ajouter une autre RETRAITE</h4>
                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" onClick={(e) => {
                    const nodes = window.document.querySelectorAll('.collapse.show');
                    if (!R.isNil(nodes) && nodes.length > 0) {
                        nodes.forEach(element => {
                            element.classList.remove(['show']);
                        });
                    }
                    setPensionState({ ...pensionState, items: pensionState.items.concat({}) });
                }}>
                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre RETRAITE
                </button>
            </footer>
        </article>
    );
};